// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__o9PAK","row":"ProcedureTreatmentSummary_row__3mT5D"};